import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { UNBLOCK_REP } from '../../constants/repTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { repSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { UNBLOCK_REP_SUCCESS, UNBLOCK_REP_ERROR } from '../../constants/messages';

export function* searchRep(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(UNBLOCK_REP, call(repAPI.unblock, params), repSchema);
    yield toastr.success('Success', UNBLOCK_REP_SUCCESS);
  } catch (e) {
    yield toastr.error(UNBLOCK_REP_ERROR);
    yield put(error(UNBLOCK_REP, e));
  } finally {
    yield put(doneIndicator(UNBLOCK_REP));
  }
}

export function* watchSearchRep() {
  yield takeEvery(UNBLOCK_REP, searchRep);
}

export default function* root() {
  yield all([
    fork(watchSearchRep)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/unblockRep.js